import { matchPath } from 'react-router'

import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'
import useChatTripPlannerReleaseState from './useChatTripPlannerReleaseState'

const tripPlannerPath = '/:regionCode/trip-planner'

type ChatTripPlannerSaveEntryPointVisibility = {
  isLoggedIn: boolean
  hasChatTripPlannerDirectEntrySignal: boolean
  hasClassicTripPlannerTrips: boolean
  hasChatTripPlannerDirectEntryDecisionError: boolean
  isLoadingChatTripPlannerDirectEntryDecision: boolean
}

export function shouldShowTripPlannerSaveEntryPoints(
  pathname = '',
  enableTripPlanner = config.ENABLE_TRIP_PLANNER,
) {
  return (
    !!enableTripPlanner ||
    !!matchPath(pathname, { path: tripPlannerPath, exact: false })
  )
}

export function shouldHideTripPlannerSaveEntryPointsForChatTripPlanner(
  {
    isLoggedIn,
    hasChatTripPlannerDirectEntrySignal,
    hasClassicTripPlannerTrips,
    hasChatTripPlannerDirectEntryDecisionError,
    isLoadingChatTripPlannerDirectEntryDecision,
  }: ChatTripPlannerSaveEntryPointVisibility,
) {
  if (!isLoggedIn || !hasChatTripPlannerDirectEntrySignal) {
    return false
  }

  if (
    hasClassicTripPlannerTrips ||
    hasChatTripPlannerDirectEntryDecisionError ||
    isLoadingChatTripPlannerDirectEntryDecision
  ) {
    return false
  }

  return true
}

function useShouldShowTripPlannerSaveEntryPoints() {
  const pathname = useAppSelector((state) => state.router.location.pathname)

  const shouldShowSaveEntryPoints = shouldShowTripPlannerSaveEntryPoints(
    pathname,
    config.ENABLE_TRIP_PLANNER,
  )
  const {
    isLoggedIn,
    hasChatTripPlannerDirectEntrySignal,
    hasClassicTripPlannerTrips,
    hasChatTripPlannerDirectEntryDecisionError,
    isLoadingChatTripPlannerDirectEntryDecision,
  } = useChatTripPlannerReleaseState(
    shouldShowSaveEntryPoints,
  )

  const shouldHideForChatTripPlanner = shouldHideTripPlannerSaveEntryPointsForChatTripPlanner(
    {
      isLoggedIn,
      hasChatTripPlannerDirectEntrySignal,
      hasClassicTripPlannerTrips,
      hasChatTripPlannerDirectEntryDecisionError,
      isLoadingChatTripPlannerDirectEntryDecision,
    },
  )

  return shouldShowSaveEntryPoints && !shouldHideForChatTripPlanner
}

export default useShouldShowTripPlannerSaveEntryPoints
